// extracted by mini-css-extract-plugin
export default {"flex-container":"PublicProduct_flex-container__bTdtb","nowrap":"PublicProduct_nowrap__hZsXc","wrap":"PublicProduct_wrap__+tH9Y","flex-item":"PublicProduct_flex-item__x+1F6"};